import React, {Component} from 'react'
import {StaticQuery, graphql} from 'gatsby'
import StructuredData from 'react-google-structured-data'

class ProductSchema extends Component {

    render () {
        const {product} = this.props

        return (
            <StaticQuery
                query={query}
                render={(data) => {
                    const siteMetadata = data.file !== null ? data.file.childJsonJson : null
                    const siteUrl = siteMetadata ? siteMetadata.siteUrl : ''
                    const images = product.images.map(image => siteUrl+image.localFile.childImageSharp.fluid.src)
            
                    return <StructuredData
                        type='Product'
                        data={{
                            sku: product.variants[0].sku,
                            name: product.title,
                            description: product.description,
                            image: images,
                            brand: {
                                '@type': 'Brand',
                                'name': product.vendor
                            },
                            offers: {
                                "@type": "Offer",
                                "url": siteUrl+"/products/"+product.handle,
                                "priceCurrency": product.variants[0].priceV2.currencyCode,
                                "price": product.variants[0].priceV2.amount,
                                "itemCondition": "https://schema.org/UsedCondition",
                                "availability": "https://schema.org/InStock",
                                "seller": {
                                    "@type": "Organization",
                                    "name": product.vendor
                                }
                            }
                        }}
                    />
                }}
            />
        )
    }
}

const query = graphql`
 {
    file(base: {eq: "site-metadata.json"}) {
      childJsonJson {
        siteUrl
      }
    }
  }
  `

export default ProductSchema